var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5145,
    y: 1.68145,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8895,
    y: 7.15801,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5496,
    y: 13.577,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5691,
    y: 20.4217,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2254,
    y: 26.8397,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.24102,
    y: 33.6844,
    width: 44.2787,
    height: 56.0434,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.2086
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6257 57.5952C19.6605 57.5952 21.3101 55.9457 21.3101 53.9109C21.3101 51.8761 19.6605 50.2266 17.6257 50.2266C15.5909 50.2266 13.9414 51.8761 13.9414 53.9109C13.9414 55.9457 15.5909 57.5952 17.6257 57.5952Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.974 72.7422C18.7446 72.7422 14.3465 69.3423 12.9545 64.7024C12.9154 64.5639 12.9094 64.4181 12.9368 64.2767C12.9643 64.1354 13.0245 64.0025 13.1126 63.8887C13.2007 63.7748 13.3142 63.6832 13.4441 63.6212C13.5741 63.5591 13.7167 63.5284 13.8606 63.5315H34.0885C34.232 63.5293 34.3739 63.5607 34.5031 63.6231C34.6323 63.6856 34.7451 63.7773 34.8325 63.891C34.92 64.0047 34.9797 64.1373 35.0068 64.2782C35.0339 64.4191 35.0278 64.5643 34.9889 64.7024C33.6084 69.3423 29.2091 72.7422 23.974 72.7422Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9304 57.5952C32.9652 57.5952 34.6148 55.9457 34.6148 53.9109C34.6148 51.8761 32.9652 50.2266 30.9304 50.2266C28.8956 50.2266 27.2461 51.8761 27.2461 53.9109C27.2461 55.9457 28.8956 57.5952 30.9304 57.5952Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftIcon);
export default __webpack_public_path__ + "static/media/nftIcon.fccb1e796e20206f9749c35e195b9e78.svg";
export { ForwardRef as ReactComponent };